import { render, staticRenderFns } from "./chevron_up.vue?vue&type=template&id=04e6b518&scoped=true&"
import script from "./chevron_up.vue?vue&type=script&lang=js&"
export * from "./chevron_up.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e6b518",
  null
  
)

export default component.exports